import React, { useContext } from "react";
import { Ad, AdLocation } from "../types";
import AdItemMedium from "../components/items/ad/medium";
import { NavLink } from "react-router-dom";
import withRedux from "../withRedux";
import Loader from "../components/loader";
import { _ } from "libs";
import NoResults from "../components/noResults";
import adSelector from "../selectors/adSelector";
import RemoteConfigContext from "../contexts/remoteConfigContext";
import { getCookieLang, getShortLang } from "../libs/detectLanguage";

const Deals = ({ ads }: { ads: Ad[] }) => {
	const remoteContext = useContext(RemoteConfigContext);
	if (remoteContext.deals?.strategy === "ext" && remoteContext.deals?.urls?.default) {
		const lang = getCookieLang() || getShortLang() || "en";
		window.open(
			remoteContext.deals.urls[lang] || remoteContext.deals.urls.default,
			"_blank",
			"noopener,noreferrer"
		);
		return null;
	}

	if (ads === null) {
		return <Loader />;
	}

	return (
		<div className="dealsPage">
			<div className="wrap">
				<h1>{_("deals.heading")}</h1>
				{ads.length === 0 ? (
					<NoResults text={_("deals.noResults")} />
				) : (
					<div className="deals">
						{ads.map((ad, index) => {
							return ad.campaign ? (
								<NavLink
									to={`/deals/${ad.campaign}`}
									className="aBlock"
									key={index}
									data-campaign={ad.campaign}
								>
									<AdItemMedium ad={ad} />
								</NavLink>
							) : (
								<a
									href={ad.link}
									className="aBlock"
									key={index}
									target="_blank"
									rel="noopener noreferrer"
								>
									<AdItemMedium ad={ad} />
								</a>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = ({ deals: { ads } }, ownProps) => {
	return { ads: adSelector(ads, AdLocation.DealsPage) };
};

export default withRedux({}, mapStateToProps)(Deals);
